import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Flex, Input, Text, Checkbox, Label } from 'theme-ui';
import {
  resetAuth,
  sendOtp,
  varifyOtp
} from '../../../redux/feature/authSlice';
import { setLoginChildPageName } from '../../../redux/feature/loginCredSlice';
import { constantLogin } from '../../../constant/constant';
import { heroViredWebUrl } from '../../../api/config';
import { CLEVER_TAP_EVENTS } from '../../../config/cleverTapEvents';
import { cleverTapEventPush } from '../../../utils/cleverTap';
import { fetchProgramType } from '../../../redux/feature/selfPacedSlice';

const LoginWithEmailOtp = () => {
  const [error, setError] = useState(false);
  const dispatch = useDispatch();
  const [counter, setCounter] = useState(120);
  const [running, setRunning] = useState(true);
  const enteredEmail = useSelector((state) => state.loginCred.enteredEmail);
  const otp = useSelector((state) => state.auth.otp);
  useEffect(() => {
    let intervalId;

    if (running && counter > 0) {
      // Start the timer if it's running and timer is greater than 0
      intervalId = setInterval(() => {
        setCounter((prevCounter) => prevCounter - 1);
      }, 1000);
    }

    if (counter === 0) {
      // Stop the timer when it reaches 0
      setRunning(false);
    }

    // Clean up the interval when component unmounts or timer is stopped
    return () => {
      clearInterval(intervalId);
    };
  }, [running, counter, dispatch]);

  const formatTime = (time) => {
    // Helper function to format time as mm:ss
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, '0');
    const seconds = (time % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  };

  const handleGoBackToHome = () => {
    dispatch(setLoginChildPageName(null));
    dispatch(resetAuth());
  };
  const otpContainerRef = useRef();
  const handleOtpOnInput = (e) => {
    const currentElement = e.target;
    const currentIndex = Array.from(otpContainerRef.current.childNodes).indexOf(
      currentElement
    );

    if (currentElement.value.length > 1) {
      currentElement.value = currentElement.value[0];
    }

    if (currentElement.value.length === 1 && currentIndex < 5) {
      otpContainerRef.current.childNodes[currentIndex + 1].focus();
    }
  };

  const handleOtpKeyDown = (e) => {
    const currentElement = e.target;
    const currentIndex = Array.from(otpContainerRef.current.childNodes).indexOf(
      currentElement
    );

    if (!/^[0-9]$/.test(e.key) && e.key !== 'Backspace') {
      e.preventDefault();
    }

    if (e.key === 'Backspace') {
      if (currentElement.value === '' && currentIndex > 0) {
        otpContainerRef.current.childNodes[currentIndex - 1].focus();
      } else {
        currentElement.value = '';
      }
    }
  };

  const handleResendOTP = () => {
    // Logic to handle resend OTP button click
    if (!running) {
      // Start the timer only if it's not already running
      setRunning(true);
      setCounter(120); // Reset timer to initial value
      // Call the API to resend OTP
      cleverTapEventPush(CLEVER_TAP_EVENTS.Login_Attempt, {
        Method_Used: 'Email OTP',
        Resend_OTP: true
      });
      dispatch(sendOtp({ value: enteredEmail, type: 'email' }));
    }
  };

  const handleLogin = async (e) => {
    let error = false;
    let enteredOtp = '';
    otpContainerRef.current.childNodes.forEach((element, index) => {
      enteredOtp += element.value;
      if (element.value == '') {
        error = true;
      }
    });

    // console.log("Otp: " + enteredOtp);

    if (error) {
      // console.log("empty otp");
    } else {
      dispatch(
        varifyOtp({ value: enteredEmail, type: 'email', otp: enteredOtp })
      );
      const payload = {
              email: enteredEmail.includes('@') ? enteredEmail : '',
              phone: enteredEmail.includes('@') ? '' : enteredEmail
            };
          
            // ✅ Dispatch fetchProgramType with the payload
            dispatch(fetchProgramType(payload));
    }
    setError(error);
    // if(action.payload.status == true)
    //     navigate("/");
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      document.getElementById('handle-email-submit-otp-click').click();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '24px'
        }}
      >
        <p className='login-label'>Mobile Number or Email ID</p>
        <p
          onClick={handleGoBackToHome}
          className='login-label'
          style={{
            color: '#5095fc',
            cursor: 'pointer'
          }}
        >
          Edit
        </p>
      </Box>
      <Input
        mt={2}
        type='text'
        value={enteredEmail}
        disabled
        sx={{
          width: '100%',
          borderRadius: '8px',
          border: '1px solid var(--Color-Border-Border, #E5EBF4)',
          background: 'var(--Color-Surface-Secondary, #F2F4FA)',
          padding: '16px',
          fontSize: '16px',
          color: '#333B48'
        }}
        className='login-label login-reset'
      ></Input>
      <Box
        style={{
          marginTop: '24px'
        }}
        className='login-label'
      >
        Enter the OTP
      </Box>
      <Flex
        ref={otpContainerRef}
        style={{
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Input
          type='number'
          onInput={handleOtpOnInput}
          onKeyDown={handleOtpKeyDown}
          className='otp-box'
          maxLength={1}
        ></Input>
        <Input
          type='number'
          onInput={handleOtpOnInput}
          onKeyDown={handleOtpKeyDown}
          className='otp-box'
          maxLength={1}
        ></Input>
        <Input
          type='number'
          onInput={handleOtpOnInput}
          onKeyDown={handleOtpKeyDown}
          className='otp-box'
          maxLength={1}
        ></Input>
        <Input
          type='number'
          onInput={handleOtpOnInput}
          onKeyDown={handleOtpKeyDown}
          className='otp-box'
          maxLength={1}
        ></Input>
        <Input
          type='number'
          onInput={handleOtpOnInput}
          onKeyDown={handleOtpKeyDown}
          className='otp-box'
          maxLength={1}
        ></Input>
        <Input
          type='number'
          onInput={handleOtpOnInput}
          onKeyDown={handleOtpKeyDown}
          className='otp-box'
          maxLength={1}
        ></Input>
      </Flex>
      {otp.verifyOtpError ? (
        <Flex
          mt={2}
          sx={{
            width: '100%',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '12px',
            lineHeight: '20px',
            color: '#E34935',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }}
        >
          <Box
            sx={{ fontSize: '18px', marginRight: '10px' }}
            className='material-symbols-outlined'
          >
            info
          </Box>
          <Box className='error-text'>{otp.verifyOtpError}</Box>
        </Flex>
      ) : (
        <></>
      )}
      {error ? (
        <Flex
          mt={2}
          sx={{
            width: '100%',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '12px',
            lineHeight: '20px',
            color: '#E34935',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }}
        >
          <Box
            sx={{ fontSize: '18px', marginRight: '4px' }}
            className='material-symbols-outlined'
          >
            info
          </Box>
          <Box className='error-text'>{constantLogin.emptyMessageOtp}</Box>
        </Flex>
      ) : (
        <></>
      )}
      <Box
        sx={{
          color: '#5D6C83',
          marginTop: '8px'
        }}
        className='login-label'
      >
        Did not receive OTP?
        {counter > 0 ? (
          <Text
            sx={{
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 600,
              fontSize: '14px',
              lineHeight: '140%',
              color: '#5095fc'
            }}
          >
            {' '}
            {formatTime(counter)}
          </Text>
        ) : (
          <Text
            sx={{
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 600,
              fontSize: '14px',
              lineHeight: '140%',
              color: '#5095fc',
              cursor: 'pointer'
            }}
            onClick={handleResendOTP}
          >
            {' '}
            Resend
          </Text>
        )}
      </Box>
      <button
        className='login-button'
        onClick={handleLogin}
        disabled={otp.verifyPending}
        id='handle-email-submit-otp-click'
      >
        Login
      </button>
    </Box>
  );
};

export default LoginWithEmailOtp;
